import { FunctionComponent, useMemo } from "react";
import { FormProvider, useForm } from "react-hook-form";
import styled from "styled-components";
import { PrimaryButton } from "../../../../../components/button";
import { Tabs } from "../../../../../components/tabs/tabs-page";
import { Field } from "../../../../../store/launch-configurations/models/internal/field";
import CustomFields from "./custom-field";
import DefaultFields from "./default-field";

const StyledTabs = styled(Tabs)`
  width: 40em;
  max-width: 100%;
`;

interface ISingleFieldOverlayProps {
  onSubmit: (d: Field.Field<string>) => void;
}

const SingleFieldOverlay: FunctionComponent<ISingleFieldOverlayProps> = ({
  onSubmit,
}) => {
  const form = useForm<Field.Field<string>>({
    defaultValues: {
      title: {},
      desc: {},
      field: "",
    },

    // TODO: add validation for new field
  });

  const tabs = useMemo(
    () => [
      {
        title: "Default Fields",
        content: <DefaultFields />,
      },
      {
        title: "Custom Fields",
        content: <CustomFields />,
      },
    ],
    []
  );

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <StyledTabs tabs={tabs} />
        <PrimaryButton type="submit">Save</PrimaryButton>
      </form>
    </FormProvider>
  );
};

export default SingleFieldOverlay;
